export const getQuery = function (state) {
  if (!state.query) {
    state.query = JSON.parse(window.sessionStorage.getItem('query'))
  }
  return state.query
}
export const getConditions = function (state) {
  if (!state.conditions) {
    state.conditions = JSON.parse(window.sessionStorage.getItem('conditions'))
  }
  return state.conditions
}
export const getLeftmenu = function (state) {
  return state.leftmenu
}
export const getEventLimitAttrItemAttr = function (state) {
  return state.eventLimitAttrItemAttr
}
export const getEventLimitAttrItem = function (state) {
  return state.eventLimitAttrItem
}
